var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('InfoFooter'),_c('div',{staticClass:"footer-bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }